import { Box, Container, Flex, Text } from '@chakra-ui/react';
import type React from 'react';
import { useEffect, useState } from 'react';
import SelectDropdown from '@/components/formComponents/Select';

import ResourceLayout from '@/components/resources/ResourceLayout';
import { getContentList } from '@/lib/apiService';
import JobListingCard from '@/components/job-board/JobsListingCard';
import type { IJob } from '@/interfaces/job-board';

const JobBoardLayout: React.FC = () => {
  const [jobs, setJobs] = useState<IJob[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');

  const [jobType, setJobType] = useState<{
    label: string;
    value: string | undefined;
  }>({
    label: 'All',
    value: undefined,
  });
  const [workplaceType, setWorkplaceType] = useState<{
    label: string;
    value: string | undefined;
  }>({
    label: 'All',
    value: undefined,
  });

  useEffect(() => {
    const filterQuery: Record<string, any> = {
      status: { in: ['Published'] },
    };
    if (jobType?.value) {
      filterQuery.job_type = jobType?.value;
    }
    if (workplaceType?.value) {
      filterQuery.workplace_type = workplaceType?.value;
    }
    getContentList<IJob>('jobs', {
      limit: 100,
      search: searchValue || undefined,
      sort: {
        created_at: 'desc',
      },
      where: filterQuery,
    })
      .then((res) => setJobs(res.content.data))
      .catch((err) => console.error(err));
  }, [jobType, workplaceType, searchValue]);

  return (
    <Flex flexDir="column">
      <Flex
        flexDir="column"
        margin="0 auto"
        borderBottom="1px solid rgba(100, 100, 140, 0.16)"
        width="100%"
        alignItems="center"
      >
        <ResourceLayout
          heading="Industry Job Board"
          desc=""
          inputPlaceHolder="Search by job title or location..."
          searchBar
          onInputChange={setSearchValue}
        />
        <Flex
          pt="40px"
          pb="15px"
          gap={{ xs: '15px', sm: '25px', md: '110px' }}
          flexWrap="wrap"
          justify="center"
        >
          <Flex alignItems="center">
            <Text
              variant="dropdownSubLink"
              display={{ xs: 'none', sm: 'block' }}
            >
              Job-Type
            </Text>
            <SelectDropdown
              name="jobType"
              value={jobType}
              onChange={(e: any) => setJobType(e)}
              options={[
                { label: 'Full Time', value: 'Full-Time' },
                { label: 'Part Time', value: 'Part-Time' },
                { label: 'Internship', value: 'Internship' },
                { label: 'All', value: undefined },
              ]}
            />
          </Flex>
          <Flex alignItems="center">
            <Text
              variant="dropdownSubLink"
              display={{ xs: 'none', sm: 'block' }}
            >
              Workplace-Type
            </Text>
            <SelectDropdown
              name="workplaceType"
              value={workplaceType}
              onChange={(e: any) => setWorkplaceType(e)}
              options={[
                { label: 'On Site', value: 'On Site' },
                { label: 'Hybrid', value: 'Hybrid' },
                { label: 'Remote', value: 'Remote' },
                { label: 'All', value: undefined },
              ]}
              width="100%"
            />
          </Flex>
        </Flex>
      </Flex>
      <Box bgColor="lightWhite" pb="100px">
        <Container maxW="1100px">
          <Flex flexDirection="column" gap="40px" pt="40px" w="100%">
            {jobs?.map((item, index) => (
              <JobListingCard
                key={index}
                job_designation={item?.job_designation}
                workplace_type={item?.workplace_type}
                job_summary={item?.job_summary_2}
                job_type={item?.job_type}
                location={item?.location_1}
                slug={item?.slug}
              />
            ))}
            {!jobs?.length && <Text textAlign="center">No data found</Text>}
          </Flex>
        </Container>
      </Box>
    </Flex>
  );
};

export default JobBoardLayout;
